module.exports = __webpack_public_path__ + "static/media/6_School of the animals_JP.9b749c9e.txt";